import axios from "axios";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
import routes from "../../configs/api";

const toggleVendor = async (vendorId) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const URL = `${routes.GET_VENDOR_LIST}/${vendorId}`;

  console.log("Toggling Vendor API:", URL);

  return new Promise((resolve, reject) => {
    axios
      .patch(
        URL,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export default toggleVendor;
